import { EventTypes } from '@/app/libs/analytics/enum/EventType';
import { EventParams } from '@/app/libs/analytics/interfaces/EventParams';
import { event } from '@/app/libs/analytics/utils/event';

export function sendClickEvent(args: Omit<EventParams, 'type'>): void {
  return event({ type: EventTypes.BUTTON, ...args });
}
